// src/components/Payment/Raisecomplaint.js
import React from 'react';

const Raisecomplaint = () => {
  return (
    <div>
      <h2>Raisecomplaint</h2>
      <p>This is the Raisecomplaint component.</p>
    </div>
  );
};

export default Raisecomplaint;
